import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NarrativeEditor from '../components/wizard/NarrativeEditor';

/**
 * Demo Narrator Page - No auth required
 * For testing and feedback purposes
 */
export default function DemoNarratorPage() {
  const navigate = useNavigate();

  // Mock claim data for demo
  const mockClaimData = {
    client_name: 'Acme Restaurant Group, LLC',
    claimant_name: 'John Smith',
    business_type: 'Restaurant & Food Service',
    zone: '3'
  };

  const mockCalculationResults = {
    totals: {
      total_loss: 507000,
      final_claim_amount: 507000,
      accountant_fees: 0,
      other_adjustments: 0
    },
    step_one: {
      benchmark_variable_profit: 245000,
      compensation_period_variable_profit: 108000,
      variable_profit_loss: 137000
    },
    step_two: {
      benchmark_revenue: 850000,
      claimant_specific_factor: 0.15,
      total_adjustment_factor: 0.18,
      incremental_revenue: 153000,
      variable_margin_percent: 0.32,
      incremental_lost_profit: 48960
    },
    benchmark: {
      period_type: 'Pre-Event Historical Period',
      start_month: 'January 2021',
      end_month: 'December 2021',
      variable_profit: 245000,
      revenue: 850000,
      variance: 12500
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Demo Banner */}
      <div className="bg-gradient-to-r from-yellow-400 to-orange-400 text-black p-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div>
            <p className="font-bold text-lg">🎭 DEMO MODE - AI Report Narrator</p>
            <p className="text-sm">Test the $150 premium feature with sample data</p>
          </div>
          <button
            onClick={() => navigate('/demo-report/demo-1')}
            className="bg-white text-black px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 transition"
          >
            ← Back to Report
          </button>
        </div>
      </div>

      <NarrativeEditor
        claimId="demo-001"
        claimData={mockClaimData}
        calculationResults={mockCalculationResults}
        eventType="Hurricane"
      />

      {/* Demo Footer */}
      <div className="bg-gray-800 text-white p-6 mt-8">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm">
            This is a demo of the AI Report Narrator premium feature ($150). 
            Sign in to generate real AI reports with your actual claim data.
          </p>
        </div>
      </div>
    </div>
  );
}
